/*
 * @Author: 肖玲
 * @Date: 2023-05-18 17:01:27
 * @LastEditTime: 2023-06-13 14:37:36
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-settle-accounts\modules\expenseReportRouter.js
 * 费用报表
 */
const expenseReportRouter = [

  // 费控系统 费用结算管理 费用报表 经销商费用计提表
  {
    path: '/costControlSystem/expense-report/dealer_fee_budget/page',
    name: 'DealerRefund',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer_fee_budget/page.vue'
      ),
    meta: {
      SecondaryMenu: '费用报表', //二级菜单
      title: '经销商费用计提表',
      breadcrumb: [
        {
          title: '费用计算管理',
        },
      ],
    },
  },
  // 费控系统 费用结算管理 费用报表 经销商费用计提表 导入
  {
    path: '/costControlSystem/expense-report/dealer_fee_budget/import',
    name: 'DealerRefundImport',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer_fee_budget/import.vue'
      ),
    meta: {
      SecondaryMenu: '费用结算管理', //二级菜单
      title: '导入计提明细',
      breadcrumb: [
        {
          title: '费用结算管理',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 费用报表 经销商拨付表
  {
    path: '/costControlSystem/expense-report/dealer_fee_allocation/page',
    name: 'DealerFeeAllocation',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer_fee_allocation/page.vue'
      ),
    meta: {
      SecondaryMenu: '费用结算管理', //二级菜单
      title: '经销商拨付表',
      breadcrumb: [
        {
          title: '费用结算管理',
        },
      ],
    },
  },
  // 费控系统 费用结算管理 费用报表 经销商拨付表 拨付数据导入
  {
    path: '/costControlSystem/expense-report/dealer_fee_allocation/import',
    name: 'DealerFeeAllocationImport',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer_fee_allocation/import.vue'
      ),
    meta: {
      SecondaryMenu: '费用结算管理', //二级菜单
      title: '拨付数据导入',
      breadcrumb: [
        {
          title: '费用结算管理',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 费用报表 经销商拨付表 拨付年汇总
  {
    path: '/costControlSystem/expense-report/dealer_fee_allocation/total',
    name: 'DealerFeeAllocationTotal',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer_fee_allocation/total.vue'
      ),
    meta: {
      SecondaryMenu: '费用结算管理', //二级菜单
      title: '经销商拨付年汇总',
      breadcrumb: [
        {
          title: '费用结算管理',
        },
      ],
    },
  },

  // 费控系统 费用结算管理 费用报表 经销商拨付表 详情
  {
    path: '/costControlSystem/expense-report/dealer_fee_allocation/detail',
    name: 'DealerFeeAllocationDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer_fee_allocation/detail.vue'
      ),
    meta: {
      SecondaryMenu: '费用结算管理', //二级菜单
      title: '经销商拨付明细',
      breadcrumb: [
        {
          title: '费用结算管理',
        },
      ],
    },
  },








  // 费控系统 费用结算管理 费用报表 经销商返款
  {
    path: '/costControlSystem/expense-report/dealer-refund',
    name: 'DealerRefund',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer-refund/Page.vue'
      ),
    meta: {
      SecondaryMenu: '费用报表', //二级菜单
      title: '经销商返款',
      breadcrumb: [
        {
          title: '费用报表',
        },
      ],
    },
  },
  // 费控系统 费用结算管理 费用报表 回款报表
  {
    path: '/costControlSystem/expense-report/payment-statement',
    name: 'paymentStatement',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/payment-statement/page.vue'
      ),
    meta: {
      SecondaryMenu: '费用报表', //二级菜单
      title: '回款报表',
      breadcrumb: [
        {
          title: '费用报表',
        },
      ],
    },
  },
  // 费控系统 费用结算管理 费用报表 经销商返款 新增经销商返款申请
  {
    path: '/costControlSystem/expense-report/add-dealer-refund/:remittance_id',
    name: 'AddDealerRefund',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer-refund/Add.vue'
      ),
    meta: {
      SecondaryMenu: '经销商返款', //二级菜单
      title: '新增经销商返款申请',
      breadcrumb: [
        {
          title: '费用报表',
        },
        {
          title: '经销商返款',
          name: 'DealerRefund',
        },
      ],
    },
  },
  // 费控系统 费用结算管理 费用报表 经销商返款 经销商返款结算明细
  {
    path: '/costControlSystem/expense-report/dealer-refund-detail/:dealer_refund_id',
    name: 'DealerRefundDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer-refund/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '经销商返款', //二级菜单
      title: '经销商返款结算明细',
      breadcrumb: [
        {
          title: '费用报表',
        },
        {
          title: '经销商返款',
          name: 'DealerRefund',
        },
      ],
    },
  },
  // 费控系统 费用结算管理 费用报表 经销商回款
  {
    path: '/costControlSystem/expense-report/dealer-refund-stats',
    name: 'DealerRefundStats',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/expense-report/dealer-refund-stats/Page.vue'
      ),
    meta: {
      SecondaryMenu: '费用报表', //二级菜单
      title: '回款列表',
      breadcrumb: [
        {
          title: '费用报表',
        },
      ],
    },
  },
]
export default expenseReportRouter
